<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO && rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="grid-content">
          <div class="title">变更前</div>
          <template v-if="form.beforeStr.guessConsultMap">
            <div class="item">咨询问题：{{form.beforeStr.guessConsultMap.title}}</div>
            <div class="item">回答类型：{{form.beforeStr.guessConsultMap.type === 10?'文字':'产品'}}</div>
            <div class="item">咨询次数：{{form.beforeStr.guessConsultMap.click_count}}</div>
            <div class="item">状态：{{form.beforeStr.guessConsultMap.is_enabl?'启用':'禁用'}}</div>
            <div class="item" v-if="form.beforeStr.guessConsultMap.type === 10">内容：{{form.beforeStr.guessConsultMap.content}}</div>
          </template>
          <template v-if="form.beforeStr.goodsMap && form.beforeStr.guessConsultMap.type === 20" >
            <div class="item">内容：</div>
            <div  v-for="(item,index) in form.beforeStr.goodsMap" :key="index" class="mt10">{{item.name}}</div>
          </template>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr ">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <template v-if="form.afterStr.guessConsultMap">
            <div class="item">咨询问题：{{form.afterStr.guessConsultMap.title}}</div>
            <div class="item">回答类型：{{form.afterStr.guessConsultMap.type === 10?'文字':'产品'}}</div>
            <div class="item">咨询次数：{{form.afterStr.guessConsultMap.click_count}}</div>
            <div class="item">状态：{{form.afterStr.guessConsultMap.is_enabl?'启用':'禁用'}}</div>
            <div class="item" v-if="form.afterStr.guessConsultMap.type === 10">内容：{{form.afterStr.guessConsultMap.content}}</div>
          </template>
          <template v-if="form.afterStr.goodsMap && form.afterStr.guessConsultMap.type === 20" >
            <div class="item">内容：</div>
            <div  v-for="(item,index) in form.afterStr.goodsMap" :key="index" class="mt10">{{item.name}}</div>
          </template>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;

      })
    }
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
</style>
